export default {"src":"/_next/static/media/icon_markdown.224ff920.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};